import React from 'react';

import { simpleColumn } from '../utils/column-helpers';
import {
  email,
  lastName,
  salesTeamColumn,
  salesUnitColumn,
} from '../utils/columns';
import UserLink from './UserLink';

export const numberLink = {
  Header: 'Number',
  accessor: 'number',
  Cell: row => <UserLink model={row.original} />,
};

export const number = simpleColumn('Number', 'number');
export const firstName = simpleColumn('First Name', 'firstName');
export const team = simpleColumn('Team', 'team');
export const salesUnit = salesUnitColumn('salesUnit');
export const salesTeam = salesTeamColumn('salesTeam');
export const roles = {
  ...simpleColumn('Roles', 'roles'),
  Cell: row => <span>{row.value.join(', ')}</span>,
};

export const listColumns = [
  numberLink,
  firstName,
  lastName,
  email,
  team,
  salesUnit,
  salesTeam,
  roles,
];

export const selectColumns = [
  number,
  firstName,
  lastName,
  email,
  team,
  salesUnit,
];
